import { Injectable, Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'getValuePipe',
  pure: true, 
})
@Injectable({ providedIn: 'root' })
export class GetValuePipe implements PipeTransform {
  transform(m: any, element: any): any {
    if (!m?.field || !element) return 0

    if (!m.field.includes('.')) {
      return element[m.field] ?? 0
    }

    const keys = m.field.split('.')
    const result = keys.reduce((acc: { [x: string]: any; }, key: string | number) => acc && acc[key], element)
    return result
  }
}